export default __webpack_public_path__ + "static/7539-1a2028bfac034d9b0861e303d0bba01f.jpg";